module.exports = __webpack_public_path__ + "media/navigation/icon-box-d49be73c.svg";